import { FaLaptopCode, FaSearch, FaSignInAlt, FaSignOutAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { ReactComponent as PercentLogo } from "../assets/images/percentMapLogo.svg";
import { useAuth } from "../AuthContext";
import { PiNotePencilFill } from "react-icons/pi";


interface MenuBarProps {
    toggleSidBar: React.Dispatch<React.SetStateAction<any>>;
    closeToggleSideBar: React.Dispatch<React.SetStateAction<any>>;
    setIsModalOpen: React.Dispatch<React.SetStateAction<any>>;
    isSignIn: boolean;
    handleGoogleLogin: () => void;
    handleGoogleLogout: () => void;
}



function MenuBar({ toggleSidBar, closeToggleSideBar, setIsModalOpen, isSignIn, handleGoogleLogin, handleGoogleLogout }: MenuBarProps) {

    // useAuth 훅 사용하여 user 정보 가져오기
    const { role } = useAuth();

    const onSearchClick = () => {
        setIsModalOpen((currentState: boolean) => !currentState);
    }

    const handleLogoClick = () => {
        window.location.href = '/admin';
    };
    return (
        <div className="flex flex-col items-center py-8 px-4 space-y-4 bg-gray-900 border-gray-700 z-50 justify-between">
            {isSignIn && role === 'ADMIN' ?
                <div className="flex flex-col items-center">
                    <Link to="/" onClick={handleLogoClick}>
                        <PercentLogo className="w-6 h-6 mb-8" />
                    </Link>
                    <Link to="/admin/sql" onClick={toggleSidBar}>
                        <div className="p-2 mb-2 cursor-pointer focus:outline-nones transition-colors duration-200 rounded-lg hover:bg-gray-800 }">
                            <FaLaptopCode className="text-gray-200 text-menu " />
                        </div>
                    </Link>
                    <Link to="/admin/create-service-post-home?page=1" onClick={closeToggleSideBar}>
                        <div className="p-2 mb-2 cursor-pointer focus:outline-nones transition-colors duration-200 rounded-lg hover:bg-gray-800 }">
                            <PiNotePencilFill className="text-gray-200 text-menu w-6 h-6" />
                        </div>
                    </Link>
                    <div className="p-2 cursor-pointer focus:outline-nones transition-colors duration-200 rounded-lg hover:bg-gray-800"
                        onClick={onSearchClick}>
                        <FaSearch className="text-gray-200 text-menu" />
                    </div>
                </div> :
                <PercentLogo className="w-8 h-8" />
            }
            {
                isSignIn ?
                    <div className="p-2 items-center cursor-pointer focus:outline-nones transition-colors duration-200 rounded-lg hover:bg-gray-800"
                        onClick={handleGoogleLogout}>
                        <FaSignOutAlt className="text-gray-200 text-menu" />
                    </div>
                    :
                    <div className="p-2 items-center cursor-pointer focus:outline-nones transition-colors duration-200 rounded-lg hover:bg-gray-800"
                        onClick={handleGoogleLogin}>
                        <FaSignInAlt className="text-gray-200 text-menu" />
                    </div>
            }
        </div >
    );
}

export { MenuBar };